export default __webpack_public_path__ + "static/media/background.d2550df5.svg";